import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=4683d4f5&scoped=true"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"
import style0 from "./Business.vue?vue&type=style&index=0&id=4683d4f5&prod&lang=css"
import style1 from "./Business.vue?vue&type=style&index=1&id=4683d4f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4683d4f5",
  null
  
)

export default component.exports